import { ReactElement } from 'react';

interface ArrowUpProps {
  yCoordinate?: number;
  xCoordinate?: number;
}

function ArrowUp({ yCoordinate, xCoordinate }: ArrowUpProps): ReactElement {
  return (
    <>
      <polygon
        transform={`translate(${xCoordinate}, ${yCoordinate}) rotate(270 0 0) scale(1)`}
        points='0,5 0,0 5,2.5'
        stroke='white'
        fill='white'
      />
    </>
  );
}

export default ArrowUp;
